import { Currency } from '@/core/currency/interfaces';

const KRW: Currency = {
    name: 'South Korean Won',
    demonym: 'South Korean',
    majorSingle: 'Won',
    majorPlural: 'Won',
    codeNumeric: '410',
    symbol: '₩',
    symbolNative: '₩',
    minorSingle: 'Jeon',
    minorPlural: 'Jeon',
    ISOdigits: 0,
    decimals: 0,
    numToBasic: 100,
    code: 'KRW',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default KRW;
